import { render, staticRenderFns } from "./main-menu.svg.vue?vue&type=template&id=d13b5ed8&"
import script from "./main-menu.svg.vue?vue&type=script&lang=js&"
export * from "./main-menu.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports